import React from 'react'
import style from './component.module.scss'
import Icon from 'components/Icon/Icon'
interface Props {
  title?: any;
  content?: any;
}
interface BtnProps {
  content?: any;
  click?: any;
  classnames?: string;
  loading?: boolean;
}


const TabsContent: React.FC<Props> = ({ title, content }) => {
  return (
    <div className={style.tabsContent} >
      <div className={style.title}>
        {title}
      </div>
      <div className={style.content}>
        {content}
      </div>
    </div>
  )
}

export default TabsContent

export const Btn: React.FC<BtnProps> = ({ content, click, classnames,loading=false }) => {
  return (
    <div className={classnames ? style[classnames] : style.btn} onClick={() => click()}>
      {loading &&<Icon icon="iconloading" className={style.loading} /> }
      {content}
    </div>
  )
}